export enum Routes {
  LOGIN = '/login',
  DASHBOARD = '/',
  MENUS = '/menus',
  PRODUCT_LIBRARY = '/items',
  OPTION_GROUPS = '/option-groups',
  INVENTORY = '/inventory',
  VENUES = '/venues',
  PRICE_SCHEMES = '/price-schemes',
  PRICE_MANAGEMENT = '/price-management',
  PRICE_RULES = '/price-rules',
  PRICE_BANDS = '/price-bands',
  ADMIN = '/admin',
  PUBLISH_SCHEDULE = '/publish-schedule',
  PUBLISH_HISTORY = '/publish-history',
  TIMETABLES = '/timetables',
  MENU_SETS = '/menu-sets',
}
